module.exports = __webpack_public_path__ + "static/media/ic-ganzhi.20b251c1.svg";